export const iconFontAwesomeHouseholdHouseUser = (
	<i className="fa-solid fa-house-user"></i>
);
